import { Component } from 'preact';
import style from './style.scss';

/**
 * The Selector component displays a selection of options for the user to pick from.
 *
 * props:
 * - options: array of option data objects. { value: any, label: string, disabled: boolean }[]
 * - selectedValue: the value of the option currently selected
 * - onOptionSelect: callback function for when the user selects a new option
 */
class Selector extends Component {

	constructor(props) {
		super(props);
		this.onSelectChange = this.onSelectChange.bind(this);
	}

	onSelectChange(evt) {
		const option = this.props.options[evt.target.selectedIndex];
		this.props.onOptionSelect(option);
	}

	render(props) {
		return (
			<div className={style.selector_wrapper}>
				<select className={style.selector} onChange={this.onSelectChange}>
					{
						props.options.map(opt => (
							<option value={opt.value}
							        disabled={opt.disabled}
							        selected={opt.value === props.selectedValue}>
								{opt.label}
							</option>
						))
					}
				</select>
			</div>
		);
	}

}

export default Selector;



// WEBPACK FOOTER //
// ./components/selector/index.js